export default "__VITE_ASSET__C7e7EgVm__"